module.exports = __webpack_public_path__ + "static/about-main-aa0fcbb58fa4769a2680363bc3b7a693.jpg";